const TOKEN_KEY = 'wol_token'
const USER_KEY = 'wol_user'

export function getToken() {
  return localStorage.getItem(TOKEN_KEY)
}

export function setToken(token) {
  localStorage.setItem(TOKEN_KEY, token)
}

export function removeToken() {
  localStorage.removeItem(TOKEN_KEY)
}

export function getUser() {
  const u = localStorage.getItem(USER_KEY)
  return u ? JSON.parse(u) : null
}

export function setUser(user) {
  localStorage.setItem(USER_KEY, JSON.stringify(user))
}

export function removeUser() {
  localStorage.removeItem(USER_KEY)
}

export function getUserId() {
  const user = getUser()
  if (user && user.id) return user.id
  // fallback: decode from JWT token
  const token = getToken()
  if (token) {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]))
      return payload.user_id
    } catch (e) { /* ignore */ }
  }
  return null
}

export function isLoggedIn() {
  return !!getToken()
}
